import { useQuery } from '@tanstack/react-query';

// models
import { AttributeOperatorModel } from '../../models/contact_attributes.model';

// services
import API from '../../services/api';

// helper
import _queryKeys from './_queryKeys';

const getAttributeOperators = async (): Promise<AttributeOperatorModel[]> => {
    const { data } = await API.getAttributesOperators();

    return data;
};

export default function useAttributeOperatorsQuery() {
    return useQuery({
        queryKey: _queryKeys.attributeOperators,
        queryFn: () => getAttributeOperators(),
        staleTime: 1000 * 24 * 60 * 60,
    });
}
